import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type AgendaItemFragment = { id: string, subType: Types.ActionItemSubTypeEnum, title: string, isChecked: boolean, actionItemsCount: number, mindsetIds?: Array<string> | null, skillIds?: Array<string> | null, activityMetricIds?: Array<string> | null, entity: string, updatedAt: string, createdAt: string, okrsConfig?: { excludedOkrIds?: Array<string> | null, okrIds?: Array<string> | null } | null, instruction?: { __typename: 'InstructionType', text?: string | null, medias: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> } | null, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, creationCadenceConfig?: { frequency: number } | null };


export type AgendaItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const AgendaItemFragmentDoc = /*#__PURE__*/ gql`
    fragment AgendaItem on AgendaItemType {
  id
  subType
  title
  isChecked
  actionItemsCount
  okrsConfig {
    excludedOkrIds
    okrIds
  }
  mindsetIds
  skillIds
  activityMetricIds
  instruction {
    text
    medias {
      ...EntityMedia
    }
    __typename
  }
  attachments {
    ...EntityMedia
  }
  entity
  updatedAt
  createdAt
  creationCadenceConfig {
    frequency
  }
}
    `;